import { render, staticRenderFns } from "./EtapaPRADA.vue?vue&type=template&id=986056fe&scoped=true&lang=pug"
import script from "./EtapaPRADA.vue?vue&type=script&lang=js"
export * from "./EtapaPRADA.vue?vue&type=script&lang=js"
import style0 from "./EtapaPRADA.vue?vue&type=style&index=0&id=986056fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986056fe",
  null
  
)

export default component.exports